import { Link } from 'react-router-dom';

export default function Programs() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const programs = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Initial Assessment',
      description: 'Comprehensive evaluation using cutting-edge technology to establish your baseline metrics and identify areas for improvement.',
      features: ['Biomechanical Analysis', 'Velocity Measurement', 'Arm Health Screening', 'Personalized Report'],
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Arm Care Program',
      description: 'Science-backed protocols designed to keep your arm healthy, strong, and ready to perform at the highest level.',
      features: ['Injury Prevention', 'Mobility Training', 'Strength Development', 'Recovery Protocols'],
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Velocity Development',
      description: 'Proven training methods to increase throwing velocity through biomechanical optimization and targeted strength work.',
      features: ['Mechanical Efficiency', 'Power Development', 'Intent Training', 'Data-Driven Progress'],
    },
    {
      icon: 'ri-trophy-line',
      title: 'College / Pro Prep Program',
      description: 'Elite-level training for athletes preparing for professional baseball, combining all aspects of performance development.',
      features: ['Advanced Metrics', 'Mental Performance', 'Showcase Preparation', 'Recruiting Support'],
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Speed & Agility',
      description: 'Specialized training to improve acceleration, lateral quickness, and change of direction for complete baseball athleticism.',
      features: ['First-Step Explosiveness', 'Base Running Speed', 'Defensive Quickness', 'Multi-Directional Movement'],
      link: '/speed-agility',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Rotational Athleticism',
      description: 'KOAS-based training that builds transferable rotational strength and total-body coordination for explosive sport performance.',
      features: ['Transferable Rotational Strength', 'Reactive Training', 'Proprioception & Impulse', 'Plyometrics', 'Body Organization in Sport'],
    },
  ];

  return (
    <section id="programs" className="py-16 md:py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4">
            THE PROGRAM AT A GLANCE
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-5"></div>
          <p className="text-base text-gray-300 max-w-3xl mx-auto">
            Customized training programs designed to maximize your potential using the latest technology and proven methodologies.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((program, index) => (
            program.link ? (
              <Link
                key={index}
                to={program.link}
                className="bg-gray-800 rounded-2xl p-6 sm:p-8 hover:bg-gray-700 transition-all duration-300 hover:shadow-2xl hover:scale-105 cursor-pointer"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-teal-500 rounded-xl mb-5">
                  <i className={`${program.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{program.title}</h3>
                <p className="text-gray-300 text-sm mb-5 leading-relaxed">{program.description}</p>
                <ul className="space-y-2">
                  {program.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className="ri-check-line text-teal-400 text-base mt-0.5"></i>
                      <span className="text-gray-300 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </Link>
            ) : (
              <div
                key={index}
                className="bg-gray-800 rounded-2xl p-6 sm:p-8 hover:bg-gray-700 transition-all duration-300 hover:shadow-2xl hover:scale-105"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-teal-500 rounded-xl mb-5">
                  <i className={`${program.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{program.title}</h3>
                <p className="text-gray-300 text-sm mb-5 leading-relaxed">{program.description}</p>
                <ul className="space-y-2">
                  {program.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className="ri-check-line text-teal-400 text-base mt-0.5"></i>
                      <span className="text-gray-300 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )
          ))}
        </div>

        <div className="text-center mt-10">
          <button onClick={scrollToContact} className="px-8 py-4 bg-teal-500 text-white text-base font-semibold rounded-full hover:bg-teal-600 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap">
            Schedule Your Assessment
          </button>
        </div>
      </div>
    </section>
  );
}